<template>
  <div>
    <print-temp />
  </div>
</template>

<script>
import printTemp from './PrintTemp.vue'
import storage from '@/utils/storagehandle'

export default {
  name: 'warehousePickingPrinttemp',
  components: {
    printTemp
  },
  destroyed () {
    storage.removeItem('taskPrintBillPickGoodList')
    storage.removeItem('taskPrintBillPickGoodsTotalPiece')
    storage.removeItem('taskPrintBillPickGoodsSku')
  }
}
</script>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehousePickingPrinttemp.vue